var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "ap-workspace-head" }, [
        _c("div", { staticClass: "ap-workspace-label" }, [
          _c("div", { staticClass: "ap-workspace-label-name" }, [
            _vm._v("\n                    Категории\n                ")
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "ap-workspace-label-btn",
              on: { click: _vm.addCategory }
            },
            [_c("SVGPlus")],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("vue-custom-scrollbar", [
        _c(
          "div",
          {
            staticClass:
              "ap-workspace-table-container workspace-admin-scroll-part"
          },
          [
            _c(
              "div",
              { staticClass: "custom-categories-table-row custom-head-row" },
              [
                _c("div", { staticClass: "custom-categories-table-label" }, [
                  _vm._v("Название")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "custom-categories-table-label" }, [
                  _vm._v("Опции")
                ])
              ]
            ),
            _vm._v(" "),
            _c("AdminCategoriesRecursive", {
              attrs: { categories: _vm.categories }
            }),
            _vm._v(" "),
            _vm.waitingResponseToCategoriesRequest
              ? _c(
                  "div",
                  { staticClass: "ap-loader-grid" },
                  [
                    _c("SpinnerTwo"),
                    _vm._v(" "),
                    _c("div", { staticClass: "ap-loader-text" }, [
                      _vm._v(
                        "\n                        Идет загрузка категорий продукции ...\n                    "
                      )
                    ])
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }